import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d33d254"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container__outer" }
const _hoisted_2 = { class: "entries__list" }

import { IonList, IonInfiniteScroll, IonInfiniteScrollContent, InfiniteScrollCustomEvent } from '@ionic/vue'
import { BasicSpinner } from '@components/basic'
interface Props {
    canLoadMore: boolean;
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicEntryModalContent',
  props: {
    canLoadMore: { type: Boolean },
    isLoading: { type: Boolean }
  },
  emits: ["loadMoreItems"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'loadMoreItems', event: InfiniteScrollCustomEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    canLoadMore: boolean;
    isLoading: boolean;
};




const loadMoreItems = (ev: InfiniteScrollCustomEvent) => {
    emit('loadMoreItems', ev)
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BasicSpinner), {
      "is-loading": props.isLoading
    }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(IonList), null, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        }),
        _withDirectives(_createVNode(_unref(IonInfiniteScroll), { onIonInfinite: loadMoreItems }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonInfiniteScrollContent), {
              loadingText: "Loading...",
              loadingSpinner: "bubbles"
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, __props.canLoadMore]
        ])
      ], 512), [
        [_vShow, !props.isLoading]
      ])
    ])
  ], 64))
}
}

})